import './CopyableText.less';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';

import { writeClipboard } from 'helpers/clipboard';

interface CopyableTextProps {
  text: string;
  label: string;
  tip?: string | null;
  mono?: boolean;
}

const COPIED_MS = 1000;

function CopyableText({
  text,
  label,
  tip,
  mono = false,
}: Readonly<CopyableTextProps>) {
  const [copied, setCopied] = useState(false);
  const reset = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (reset.current) clearTimeout(reset.current);
    },
    [],
  );

  const copy = async () => {
    if (!(await writeClipboard(text))) return;
    setCopied(true);
    if (reset.current) clearTimeout(reset.current);
    reset.current = setTimeout(() => setCopied(false), COPIED_MS);
  };

  const shownTip = copied ? 'Copied' : tip;
  const button = (
    <button
      type="button"
      className={`CopyableText${copied ? ' CopyableText--copied' : ''}${mono ? ' CopyableText--mono' : ''}`}
      aria-label={label}
      onClick={copy}
    >
      <span className="CopyableText__text">{text}</span>
      {copied ? <CheckOutlined /> : <CopyOutlined />}
    </button>
  );

  return shownTip ? (
    <Tooltip title={shownTip} placement="topLeft">
      {button}
    </Tooltip>
  ) : (
    button
  );
}

export default CopyableText;
